export const SEARCH_FILTERS = [ 'Card Database', 'Batches', 'Inventory' ]

/**
 * "Inventory" only exists when the `/search` response can carry the inventory
 * block (CDP-2508, pilot-gated), so the pill and the dropdown option are hidden
 * for everyone else — a filter that can never return anything is worse than no
 * filter. Callers pass `isSearchInventoryEnabled()`.
 */
export const searchFilters = (withInventory = false) =>
  SEARCH_FILTERS.filter(filter => filter !== 'Inventory' || withInventory)

export const CANCEL_SUBSCRIPTION_FEEDBACK = [
  { label: 'It’s too expensive', field: 'too_expensive' },
  { label: 'Some features are missing', field: 'missing_features' },
  { label: 'I’m switching to a different service', field: 'switched_service' },
  { label: 'I don’t use the service enough', field: 'unused' },
  { label: 'Customer service was less than expected', field: 'customer_service' },
  { label: 'Ease of use was less than expected', field: 'too_complex' },
  { label: 'Quality was less than expected', field: 'low_quality' },
  { label: 'Other reason', field: 'other' },
]
